export default {
  bind(el) {
    // 样式禁止选择
    el.style.userSelect = "none";
    el.style.webkitUserSelect = "none"; // iOS Safari
    el.style.webkitTouchCallout = "none"; // iOS 长按菜单

    // 禁止右键菜单（PC）
    el.__noSelectContextMenu__ = (e) => e.preventDefault();
    el.addEventListener("contextmenu", el.__noSelectContextMenu__);

    // 禁止文本选中（PC）
    el.__noSelectStart__ = (e) => e.preventDefault();
    el.addEventListener("selectstart", el.__noSelectStart__);

    // 模拟长按拦截（移动端）
    let pressTimer = null;
    el.__noSelectTouchStart__ = (e) => {
      if (e.touches.length > 1) return; // 多指操作不拦截
      pressTimer = setTimeout(() => {
        e.preventDefault(); // 长按时才阻止默认行为
      }, 350); // 自定义长按阈值（ms）
    };
    el.__noSelectTouchEnd__ = () => {
      clearTimeout(pressTimer);
    };

    el.addEventListener("touchstart", el.__noSelectTouchStart__);
    el.addEventListener("touchend", el.__noSelectTouchEnd__);
    el.addEventListener("touchmove", el.__noSelectTouchEnd__); // 滑动取消长按
  },
  unbind(el) {
    el.removeEventListener("contextmenu", el.__noSelectContextMenu__);
    el.removeEventListener("selectstart", el.__noSelectStart__);
    el.removeEventListener("touchstart", el.__noSelectTouchStart__);
    el.removeEventListener("touchend", el.__noSelectTouchEnd__);
    el.removeEventListener("touchmove", el.__noSelectTouchEnd__);

    delete el.__noSelectContextMenu__;
    delete el.__noSelectStart__;
    delete el.__noSelectTouchStart__;
    delete el.__noSelectTouchEnd__;
  }
};